import { Button, Card } from "antd";
import "../styles/index.css";
import { TelenganaNorthenApiService } from "../httpsservice/ApiService";
import { useLoaderData, useParams } from "react-router-dom";
import { formatDate } from "../utils";
import { NotFound } from "../../common";
import PendingPageTGN from "./PendingPageTGN";
import backHomeLogo from "../static/back-home-tgnpdcl-logo.svg";

const StatusPageTG = () => {
  const { txn_id } = useParams();
  // Allow alphanumeric, hyphens, underscores, and dots - common in transaction IDs
  const sanitizedTxnId = txn_id?.replace(/[^a-zA-Z0-9._-]/g, '') || '';
  const txndata = useLoaderData();

  const handelDownload = async () => {
    try {
      const queryData = { txn_id: sanitizedTxnId };
      const response = await TelenganaNorthenApiService.downloadInvoice(queryData, {
        responseType: "blob",
      });

      const fileType = "application/pdf";
      if (fileType !== "application/pdf") {
        console.error("⚠️ Invalid response type received:", fileType);
        return;
      }
      const blob = new Blob([response], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "invoice.pdf";
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("❌ Error downloading file:", error);
    }
  };

  return (
    <>
    {
     txndata?.status === "PENDING" ? (
       <PendingPageTGN />
     ) : !["SUCCESS", "FAILURE"]?.includes(txndata?.status) ? <NotFound /> : (
      <div className="tgnpdcl-main-wrapper-telangana">
        <div className="tgnpdcl-center-container">
          <div className="tgnpdcl-center-box-bill-status-page">
            <Button
              className="tgnpdcl-back-home-status"
              icon={<img src={backHomeLogo} alt="Back Home" style={{ width: 10.5, height: 10.5 }} />}
              onClick={() => {
                window.location.href = "/TGNPDCL/Billpay";
              }}
            >
              Back Home
            </Button>
            <Card
              className="tgnpdcl-service-number-card-status-page"
              cover={
                <div className="tgnpdcl-payment-status">
                  <div className="tgnpdcl-tel-north-logo-main">
                    <img
                      alt="TGNPDCL"
                      className="tgnpdcl-logo"
                      src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/tel-north-main-logo.svg"
                      style={{ width: '51.5px', height: '46px' }}
                    />
                    <span className="tgnpdcl-elecricity-title">
                      NORTHERN POWER DISTRIBUTION COMPANY OF TELANGANA LIMITED
                    </span>
                  </div>
                  {txndata?.status === "SUCCESS" ? (
                    <div className="tgnpdcl-payment-status-logo-name">
                      <img
                        alt="Success"
                        className="tgnpdcl-status-icon"
                        src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/Success.svg"
                      />
                      <p className="tgnpdcl-payment-success-text-tg">Payment Successful!</p>
                    </div>
                  ) : (
                    <div className="tgnpdcl-payment-status-logo-name">
                      <img
                        alt="Failed"
                        className="tgnpdcl-status-icon"
                        src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/failed_icon.svg"
                      />
                      <p className="tgnpdcl-payment-failure-text-tg">Payment Failed!</p>
                    </div>
                  )}
                </div>
              }
            >
              {txndata?.status === "SUCCESS" && (
                <div className="tgnpdcl-status-table-wrapper">
                  <div className="tgnpdcl-status-table-container">
                    <table className="tgnpdcl-status-table">
                    <tbody>
                      <tr>
                        <td>Receipt No. </td>
                        <td>{txndata?.transaction_no || "NA"}</td>
                      </tr>
                      <tr>
                        <td>Receipt Date </td>
                        <td>{txndata?.transaction_date ? formatDate(txndata.transaction_date) : "NA"}</td>
                      </tr>
                      <tr>
                        <td>Consumer Name </td>
                        <td>{txndata?.consumer_name || "NA"}</td>
                      </tr>
                      <tr>
                        <td>Service No. </td>
                        <td>{txndata?.service_no || "NA"}</td>
                      </tr>
                      <tr>
                        <td>Unique Service No. </td>
                        <td>{txndata?.unique_service_no || "NA"}</td>
                      </tr>
                      <tr>
                        <td>Circle Code </td>
                        <td>{txndata?.circle_code || "NA"}</td>
                      </tr>
                      <tr>
                        <td>ERO Name </td>
                        <td>{txndata?.ero_name || "NA"}</td>
                      </tr>
                      <tr>
                        <td>Bill Amount </td>
                        <td>
                        ₹{" "}
                          {txndata?.bill_amount
                            ? parseFloat(txndata.bill_amount).toFixed(2)
                            : "0.00"}
                        </td>
                      </tr>
                      <tr>
                        <td>Arrears Amount </td>
                        <td>
                        ₹{" "}
                          {txndata?.arrears_amount
                            ? parseFloat(txndata.arrears_amount).toFixed(2)
                            : "0.00"}
                        </td>
                      </tr>
                      <tr>
                        <td>ACD Amount </td>
                        <td>
                        ₹{" "}
                          {txndata?.acd_amount
                            ? parseFloat(txndata.acd_amount).toFixed(2)
                            : "0.00"}
                        </td>
                      </tr>
                      <tr>
                        <td>Total Amount </td>
                        <td>
                        ₹{" "}
                          {txndata?.total_amount
                            ? parseFloat(txndata.total_amount).toFixed(2)
                            : "0.00"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  </div>
                </div>
              )}
              {(
                <>
                  {txndata?.status === "SUCCESS" ? (
                    <div className="tgnpdcl-receipt-buttons-tg">
                      <Button
                        className="tgnpdcl-make-another-payment-tg"
                        size="large"
                        block
                        onClick={() => {
                          window.location.href = "/TGNPDCL/Billpay";
                        }}
                      >
                        Make Another Payment
                      </Button>
                      <Button
                        className="tgnpdcl-download-receipt-tg"
                        size="large"
                        block
                        onClick={handelDownload}
                      >
                        Download Receipt
                      </Button>
                    </div>
                  ) : (
                    <div className="tgnpdcl-receipt-buttons-tg">
                    <Button
                      className="tgnpdcl-retry-payment-tg"
                      size="large"
                      block
                      onClick={() => {
                        window.location.href = "/TGNPDCL/Billpay";
                      }}
                    >
                      Retry Payment
                    </Button>
                    </div>
                    
                  )}
                </>
              )}
            </Card>
              <img
                alt="poweredby-easebuzz-logo-status-page"
                className="tgnpdcl-poweredby-easebuzz-logo-status-page"
                src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/poweredbyeasebuzz.png"
              />
          </div>
        </div>
      </div>
     ) 
    }
    </>
  );
};

export default StatusPageTG;
